
import React, {Component} from 'react'
import {Card, Modal, ModalBody} from 'reactstrap';
import SaleCardView from "../../components/sale/SaleCardView";
import SaleDetailView from "../../components/sale/SaleDetailView";

var translator = require('../../utils/translator/translator');
var stateManager = require('../../utils/state/stateManager.js');
var stringUtil = require('../../utils/string/stringUtil');
var dateUtil = require('../../utils/dateUtil/dateUtil');
var constants = require('../../utils/domain/constants');
var saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');

const arraySort = require('array-sort');

class SlotsOverview extends Component 
{

    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.tabs = [];
        this.state.tabs.push("5 min");
        this.state.tabs.push("10 min");
        this.state.tabs.push("15 min");
        this.state.selectedTab = this.state.tabs[0];
        
        this.state.slots = [];
        this.state.selectedSlotIndex = -1;
        
    }

    render()
    {
        this.convertToSlots();

        return <div className='h-100'>
                    <div className='h-100'>
                        {this.renderToolbar()}
                        {this.renderBody()}
                    </div>
                    {this.renderSaleDetailModalDialogue()}
                </div>
    }

    renderToolbar()
    {
        return <div className='d-flex flex-row justify-content-end' style={{marginRight:'0px'}}>
                    <div style={{width:'20vw'}}>
                        <nav style={{
                                    position: "relative",
                                    border: "1px solid #05149e"
                                    }}>

                                        <div
                                            style={{
                                                display: "flex"
                                            }}
                                        >
                            {this.state.tabs.map((item) => {
                                return (
                                <span
                                    style={{
                                    flexGrow: 1,
                                    display: "block",
                                    padding: "5px",
                                    textDecoration: "none",
                                    textAlign: 'center',
                                    color: this.state.selectedTab === item ? "white" : "var(--colors-primary)",
                                    background: this.state.selectedTab === item ? "var(--colors-primary)" : "var(--background-color)",
                                    borderRight: '1px solid var(--colors-primary)',
                                    cursor:'pointer',
                                    fontSize:'0.8rem'
                                    }}
                                    onClick={()=>
                                    {
                                        this.state.selectedTab = item;
                                        this.setState({});
                                    }}
                                >
                                    {item}
                                </span>
                                );
                            })}
                            </div>
                        </nav>
                    </div>
                </div>
    }

    renderBody()
    {
        if (this.state.slots.length <= 0)
        {
            return <div className='h-100 caption primary-color d-flex justify-content-center align-items-center'>
                            {translator.getLabel("no_sales_found")}
                    </div>
        }

        return <div className='h-100' style={{marginLeft:'0px', marginRight:'10px', marginTop:'10px'}}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'20%', verticalAlign:'top', 
                                        borderRight:'1px solid var(--colors-primary)'}}>
                                <div style={{minHeight:'70vh', marginRight:'10px',}}>
                                    {this.renderLeftBar()}
                                </div>
                            </td>
                            <td style={{verticalAlign:'top'}}>
                                <div style={{minHeight:'70vh', marginLeft:'10px',}}>
                                    {this.renderRightBar()}
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

    }

    renderLeftBar()
    {
        let components = [];

        for (var index = 0; index < this.state.slots.length; index++)
        {
            let positon = index;
            let slot = this.state.slots[index];

            let background = "var(--background-color)";
            let color = null;
            if (index == this.state.selectedSlotIndex)
            {
                background = "var(--colors-primary)";
                color = "white";
            }

            components.push(<Card style={{background:background, color:color, marginBottom:'2px',
                                          paddingTop:'10px', paddingBottom:'10px', paddingLeft:'10px'}} 
                                  onClick={()=>
                                            {
                                                this.state.selectedSlotIndex = positon;
                                                this.setState({});
                                            }}>
                                <div style={{fontSize:'1.1rem'}}>{slot.label} ({slot.sales.length})</div>
                            </Card>);

        }
        return components;
    }

    renderRightBar()
    {
        if (this.state.selectedSlotIndex == -1)
            return;

        var sales = this.state.slots[this.state.selectedSlotIndex].sales;

        let components = [];
        
        sales.forEach (sale =>
        {
            components.push(<div onClick={()=>
                                    {
                                        this.state.selectedSale = sale;
                                        this.setState({});
                                    }}>
                                <SaleCardView sale={sale}/>
                            </div>);
        })
        
        return <div>
                    {components}
                </div>

    }

    convertToSlots()
    {
        let sales = this.getSales();
        
        this.state.slots = [];
        let lastSlot = null;
        sales.forEach(sale =>
        {
            var dueTime = dateUtil.convertToLocalStandard(sale.dueDateTime);
            var hour = dateUtil.formatDate(dueTime, "HH").padStart(2, "0");
            var min = this.roundToNearestMinute(dateUtil.formatDate(dueTime, "mm"));
            var label = `${hour}:${min}`
            if (lastSlot == null || lastSlot.label != label)
            {
                lastSlot = {};
                lastSlot.label = label;
                lastSlot.sales = [];
                this.state.slots.push(lastSlot)
            }
            lastSlot.sales.push(sale);
        });

        if (this.state.selectedSlotIndex < 0 || 
            this.state.selectedSlotIndex >= this.state.slots.length)
        {
            this.state.selectedSlotIndex = -1;
            if (this.state.slots.length > 0)
                this.state.selectedSlotIndex = 0;
        }
    }

    getSales()
    {
        let sales = stateManager.getStore().getState().todaySales;
        sales = sales.filter(sale => !saleCommonUtility.isCancelled(sale) && 
                                     sale.saleType != constants.SaleTypeHold &&
                                     stringUtil.isStringNullOrEmpty(sale.actualDispatchDateTime) && 
                                     stringUtil.isStringNullOrEmpty(sale.finalStationCompletionDateTime))
        
        return arraySort(sales, ["dueDateTime", "dateTime"]);
    }

    roundToNearestMinute(minute)
    {
        minute = minute * 1;
        let multipler = 5;
        if (this.state.selectedTab == "10 min")
            multipler = 10;


        if (this.state.selectedTab == "15 min")
            multipler = 15;
        
        var result = Math.ceil(minute / multipler) * multipler;
        result = result + "";
        return result.padStart(2, "0");
    }

    renderSaleDetailModalDialogue()
    {
        if (this.state.selectedSale == null)
            return;

        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'30vw', maxWidth:'30vw'}}
                        toggle={()=>
                                {
                                    this.state.selectedSale = null;
                                    this.setState({});
                                }} >
                    <ModalBody>
                        <div>
                            <div style={{maxHeight:'80vh', overflowY:'auto'}}>
                                <SaleDetailView sale={this.state.selectedSale}
                                                onDispatch={()=>
                                                    {
                                                        this.state.selectedSale = null;
                                                        this.setState({});
                                                    }}/>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>);
    }
}

export default SlotsOverview;